/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ChecklistItemAnswer = typeof ChecklistItemAnswer[keyof typeof ChecklistItemAnswer];


export const ChecklistItemAnswer = {
  NotChecked: 'NotChecked',
  CheckedPositive: 'CheckedPositive',
  CheckedNegative: 'CheckedNegative',
} as const;
